<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-half">
        <!-- 저장 -->
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>

        <div class="box">
          <admin-box-item title="일정 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <!-- 그룹 드롭다운 리스트 선택 -->
                <admin-form-item label="*팀 선택">
                  <div v-if="param_group_id!==''">{{ selectedGroup }}</div>
                  <lp-adm-drop-input ref="adminput"
                                     :data.sync="groupList"
                                     :selectVal="selectedGroup"
                                     @onSelect="res => group_id=res.value"
                                     placeholder="팀 선택"
                                     width="160px"
                                     listAlign="center"
                                     style="display:inline-block; margin-right:4px;" v-else></lp-adm-drop-input>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="*시작~종료 날짜">
                  <div class="flex" style="flex-wrap:wrap">
                    <admin-date-picker
                      :data="value.start"
                      type="datetime"
                      @setDate="val=> value.start = val"></admin-date-picker>
                    <div class="lp-dating">&#126;</div>
                    <admin-date-picker
                      :data="value.end"
                      type="datetime"
                      @setDate="val=> value.end = val"></admin-date-picker>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="*일정 제목">
                  <input class="input"
                         :value="value.title"
                         @input="e => value.title = e.target.value"
                         placeholder="일정 제목을 입력해주세요."
                         type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="*일정 설명">
                  <lp-editor :text.sync="value.desc"></lp-editor>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <lp-check-bool :checked-val.sync="value.all_day"
                               label="하루종일"></lp-check-bool>
              </div>

              <!--<div class="column is-full">
                <admin-form-item label="반복">
                  <div class="flex">
                    <div class="lp-recursive-box"
                         :class="{'selected': value.duration===0}"
                         @click="clickRecursive(0)">안함</div>
                    <div class="lp-recursive-box"
                         :class="{'selected': value.duration===1}"
                         @click="clickRecursive(1)">매일</div>
                    <div class="lp-recursive-box"
                         :class="{'selected': value.duration===7}"
                         @click="clickRecursive(7)">매주</div>
                    <div class="lp-recursive-box"
                         :class="{'selected': value.duration===14}"
                         @click="clickRecursive(14)">2주</div>
                    <div class="lp-recursive-box"
                         :class="{'selected': value.duration===30}"
                         @click="clickRecursive(30)">매달</div>
                    <div class="lp-recursive-box"
                         :class="{'selected': value.duration===365}"
                         @click="clickRecursive(365)">매년</div>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="value.duration!==0">
                <admin-form-item label="마지막 날짜">
                  <admin-date-picker
                    :data="value.duration_end"
                    @setDate="val=> value.duration_end = val"></admin-date-picker>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="장소">
                  <input class="input"
                         :value="value.place"
                         @input="e => value.place = e.target.value"
                         placeholder="장소를 입력해주세요."
                         type="text">
                </admin-form-item>
              </div>
              -->
            </div>
          </admin-box-item>
        </div>

        <!-- 저장 -->
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";
  import LpEditor from "../../../module/common/LpEditor";
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import GroupMixin from "@/mixins/GroupMixin"
  import CreateMixin from "@/mixins/CreateMixin"

  export default {
    name: 'CalendarCreate',
    mixins: [
      GroupMixin,
      CreateMixin
    ],
    components: {
      LpCheckBool,
      LpEditor,
      LpAdmDropInput
    },
    data() {
      return {
        group_id: 0,
        groupList: [],
        value: {
          title:'',
          desc:'',
          start:'',
          end:'',
          duration:0,
          duration_end:'',
          place:'',
          all_day:false,
          is_attend:false
        }
      }
    },
    created() {
      this.getData();
    },
    computed: {
      selectedGroup() {
        let label = '';
        this.groupList.forEach(item=>{
          if(item.value===this.group_id) {
            label = item.label;
          }
        })
        return label;
      },
    },
    watch: {
      $route() {
        this.getData();
      }
    },
    methods: {
      clickRecursive(number) {
        this.value.duration = number;
      },
      getData() {
        this.getGroupList('groupList');
        this.value = {
          title:'',
          desc:'',
          start:'',
          end:'',
          duration:0,
          duration_end:'',
          place:'',
          all_day:false,
          is_attend:false
        };
        let calendar_id = this.$route.query.calendar_id;
        this.group_id = this.$route.query.group_id ? parseInt(this.$route.query.group_id) : '';
        if(this.group_id === '')
          this.group_id = this.param_group_id;
        if(calendar_id) {
          this.$axios.get(this.getUrl(`group/${this.group_id}/calendar/${calendar_id}`)).then(res=>{
            this.group_id = res.data.group;
            this.value = res.data;
          })
        }
      },
      saveData() {
        let calendar_id = this.$route.query.calendar_id;
        let group_id = this.$route.query.group_id;
        if(this.group_id===0 || this.group_id==='') {
          this.toast('팀을 선택하세요.');
          return;
        }
        let err = '';
        if(this.value.title==='') err = '일정 제목을 입력하세요.';
        if(this.value.desc==='') err = '일정 내용을 입력하세요.';
        if(this.value.start==='') err = '시작 날짜를 선택하세요.';
        if(this.value.end==='') err = '종료 날짜를 선택하세요.';

        if(err) {
          this.toast(err);
          return;
        }
        if(calendar_id) {
         this.$axios.patch(this.getUrl(`group/${group_id}/calendar/${calendar_id}`), this.value).then(res=>{
           if(res.status===200) {
             this.toast('저장되었습니다.');
             this.$router.replace(this.getPath('group/calendar'));
           }
         })
        }
        else {
          this.$axios.post(this.getUrl(`group/${this.group_id}/calendar`), this.value).then(res=>{
            if(res.status===200) {
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('group/calendar'));
            }
          })
        }
      }
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .lp-recursive-box
    border 1px solid #777
    border-radius 3px
    margin-right 8px
    padding 6px 14px
    color #777
    cursor pointer

  .selected
    background-color $primary
    color white
</style>
